import styled from '@emotion/styled';
import { colors } from './GlobalStyles';

interface Props {
    color: string;
}

export const Button = styled.button<Props>`
    border-radius: 10px 0px;
    font-weight: 900;
    padding: 0.75em 1em;
    font-size: 16px;
    border: ${({ color }) =>
        (color === 'blue' && `2px solid ${colors.blue}`) ||
        (color === 'navy' && `2px solid ${colors.navy}`) ||
        (color === 'white' && `2px solid ${colors.white}`) ||
        (color === 'gold' && `2px solid ${colors.gold}`)};
    color: ${({ color }) =>
        (color === 'white' && `${colors.white}`) ||
        (color === 'blue' && `${colors.white}`) ||
        (color === 'navy' && `${colors.navy}`) ||
        (color === 'gold' && `2px solid ${colors.navy}`)};
    background: ${({ color }) =>
        (color === 'blue' && `${colors.blue}`) || color === 'navy' || ('gold' && `none`)};
`;
